import styled from 'styled-components';
import tw from 'twin.macro';

export const Container = styled.div`
  ${tw`flex flex-wrap  w-full mx-auto`};
  ${({ section }) => section && `padding-top: 43px; padding-bottom:5rem;`};
`;
